import Request from "@wwdev/bootstrap/Request";

class SearchRequest extends Request {
	clearFilterByTreeId(treeId) {
		try {
			delete this.request.filter[treeId];
		} catch (err) {
		}
	}

	setModule(module) {
		this.setByKeyValue('module', module)
		this.request.module = module;
	}

	setPage(page) {
		this.request.page = page;
	}

	setLimit(limit) {
		this.request.limit = limit;
	}

	setSort(sort) {
		this.request.order = sort;
	}

	setAmountPerPage(perPage) {
		this.request.limit = perPage;
	}

	hasFilterGroup(treeId) {
		if (!this.request.hasOwnProperty('filter')) {
			return false;
		}
		if (this.request.filter.hasOwnProperty(treeId)) {
			return true;
		}

	}

	hasFilter(treeId, id) {
		if (this.hasFilterGroup(treeId)) {
			return this.request.filter[treeId].hasOwnProperty(id);
		}
		return false;
	}

	clearFilter(treeId, id) {
		if (!this.hasFilter(treeId, id)) return;
		delete this.request.filter[treeId][id]
	}

	addFilter(treeId, filterId, filterTitle) {
		if (!this.request.hasOwnProperty('filter'))
			this.request.filter = {};
		if (!this.request.filter.hasOwnProperty(treeId))
			this.request.filter[treeId] = {}

		this.request.filter[treeId][filterId] = filterTitle;
	}

	doCountRequest(callback) {
		jQuery.get('?count=1&search=' + btoa(JSON.stringify(this.request)), callback);
	}
}


export default new SearchRequest();